import { inject, Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';

import { LegalEntitiesMap, LegalEntity } from './legal-entities.model';
import { UserLegalEntitiesResponse, UserLegalEntity } from './user';

@Injectable({
  providedIn: 'root',
})
export class LegalEntityModelMapper {
  private readonly logger = inject(NGXLogger);

  mapToLegalEntityMap(legalEntitiesResponse: UserLegalEntitiesResponse): LegalEntitiesMap {
    return new Map(
      legalEntitiesResponse.map(({ legalEntities, countryCode }): [string, LegalEntity[]] => [
        countryCode,
        this.mapLegalEntitiesForCountry(legalEntities, countryCode),
      ]),
    );
  }

  private mapLegalEntitiesForCountry(legalEntities: UserLegalEntity[], country: string): LegalEntity[] {
    if (legalEntities.length === 0) {
      this.logger.warn(`#CDFFF0161 There are no legal entities for ${country}`);
      return [];
    }

    return legalEntities
      .map((response) => this.mapToLegalEntity(response))
      .filter(({ dpNr }, i) => this.filterLegalEntity(dpNr, i, country));
  }

  private filterLegalEntity(dpNr: string, i: number, country: string) {
    if (!dpNr) {
      // DpNr missing, discard the entry
      this.logger.warn(
        `#CDFTF0159 Distribution partner number is missing in legal entities for ${country} at position [${i}], skipping entry`,
      );
      return false;
    }
    return true;
  }

  private mapToLegalEntity(legalEntity: UserLegalEntity): LegalEntity {
    return {
      name: legalEntity.name,
      dpNr: legalEntity.distributionPartnerNr,
    };
  }
}
